import { HomeRankingTabEnum } from "@enums";

export const HOME_TOP_TABS = [
    { id: HomeRankingTabEnum.WHATS_TOP, title: 'What\'s Top' },
    { id: HomeRankingTabEnum.WHATS_GROWING, title: 'What\'s Growing' }
];

export const HOME_TABLE_COL_HIGHLIGHT_STYLE = {
    color: '#fff',
    filter: 'drop-shadow(0px 0px 10px #00E1AF80)',
    fontWeight: '700',
}

export const EMPTY_CELL_VALUE = '-';